import { DatabaseTwoTone } from '@ant-design/icons';
import { Space, Table, Tooltip } from 'antd';
import { FC, useEffect, useState } from 'react';
import { Device, DevicePoint } from '../../../api/scada';
import styles from './index.module.scss';
import classNames from 'classnames';
import { EllipsisSpan, Button, Modal } from '@maxtropy/components';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { isNil } from 'lodash-es';

interface MonitorModalProps {
  showModal: boolean;
  title: string;
  listTitle: string;
  closeModal: () => void;
  deviceList: Device[];
}

const columns = [
  {
    title: '数据属性',
    dataIndex: 'dataPropertyName',
    key: 'dataPropertyName',
  },
  {
    title: '实时数值',
    dataIndex: 'value',
    key: 'value',
    render: (v?: string) => <EllipsisSpan value={isNil(v) ? '--' : Number(v).toFixed(2)} />,
  },
  {
    title: '时间',
    dataIndex: 'acquisitionTime',
    key: 'acquisitionTime',
    render: (v: string) => <EllipsisSpan value={v ? `${dayjs(v).format('YYYY-MM-DD HH:mm:ss')} ` : '--'} />,
  },
];

const MonitorModal: FC<MonitorModalProps> = ({ showModal, title, listTitle, closeModal, deviceList }) => {
  const [currentDeviceIndex, setCurrentDeviceIndex] = useState<number>(-1);
  const [dataSource, setDataSource] = useState<DevicePoint[]>([]);

  const clickDeviceItem = (index: number) => {
    setCurrentDeviceIndex(index);
  };

  const bildColumns = [
    ...columns,
    {
      title: '操作',
      width: 100,
      render: (record: DevicePoint) => (
        <Space>
          <Button type="link">
            <Link
              target="_blank"
              to={`/data/history/device?deviceId=${deviceList?.[currentDeviceIndex]?.id}&dataPropertyId=${record.dataPropertyId}`}
            >
              详情
            </Link>
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    setCurrentDeviceIndex(0);
  }, [deviceList]);

  useEffect(() => {
    setDataSource(deviceList?.[currentDeviceIndex]?.propertyData || []);
  }, [deviceList, currentDeviceIndex]);

  return (
    <Modal
      open={showModal}
      title={title}
      size="big"
      maskClosable={false}
      onCancel={closeModal}
      destroyOnClose
      footer={[
        <Button key="back" onClick={closeModal}>
          取消
        </Button>,
      ]}
    >
      <div className={styles.leftList}>
        <div className={styles.title}>{listTitle || '设备列表'}</div>
        <div className={styles.deviceList}>
          {deviceList?.map((item, index) => (
            <div
              key={index}
              onClick={() => clickDeviceItem(index)}
              className={classNames(styles.deviceItem, index === currentDeviceIndex && styles.selected)}
            >
              <DatabaseTwoTone />
              {item?.name?.length < 6 ? (
                <span className={styles.label}>{item?.name}</span>
              ) : (
                <Tooltip placement="right" title={item?.name}>
                  <div className={styles.txt}>{item?.name}</div>
                </Tooltip>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className={styles.rightTable}>
        <Table
          dataSource={dataSource}
          scroll={{ y: 300 }}
          rowKey="id"
          columns={bildColumns}
          pagination={{
            showQuickJumper: true,
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50'],
          }}
        />
      </div>
    </Modal>
  );
};

export default MonitorModal;
